<template>
  <div v-if="isInit" class="fidelity-program-slider">
    <Swiper
      class="swiper fidelity-program-slider__swiper-container"
      :options="swiperOption"
    >
      <SwiperSlide
        v-for="(item, key) in items"
        :key="`image-product-${key}`"
        class="fidelity-program-slider__slide"
      >
        <div class="fidelity-program-slider__card">
          <span
            class="fidelity-program-slider__card-title"
            v-text="item.title"
          ></span>
          <span
            class="fidelity-program-slider__card-description"
            v-text="item.description"
          ></span>
          <a
            :href="item.url"
            class="base-btn base-btn--secondary fidelity-program-slider__card-button"
            v-text="item.button"
          ></a>
        </div>
      </SwiperSlide>
    </Swiper>
    <div
      v-if="items.length > 1"
      class="fidelity-program-slider__swiper-border fidelity-program-slider__swiper-border--left"
    ></div>
    <div
      v-if="items.length > 1"
      class="fidelity-program-slider__swiper-border fidelity-program-slider__swiper-border--right"
    ></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Breakpoint } from '../utils/breakpoints';

export default {
  name: 'FidelityProgramSlider',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      isInit: false,
    };
  },
  computed: {
    swiperOption() {
      return {
        slidesPerView: this.$matchMedia[Breakpoint.M] ? 2.25 : 1.1,
        spaceBetween: 10,
      };
    },
  },
  created() {
    this.isInit = true;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/components/swiper';

.fidelity-program-slider {
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
  width: 100%;

  &__swiper-container {
    padding: 0 1em;

    @include breakpoint($breakpoint-l) {
      padding: 0 1.875em;
    }
  }

  &__swiper {
    overflow: unset;
    width: 100%;
  }

  &__slide {
    height: auto;
  }

  &__card {
    $padding: 1.25em;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: calc(100% - #{2 * $padding});
    width: 87%;
    padding: $padding;
    background-color: $color-white;
    border-radius: 0.675em;
  }

  &__card-title,
  &__card-description {
    font-size: 0.875em;
  }

  &__card-title {
    font-weight: bold;
    color: $color-black;
  }

  &__card-description {
    flex-grow: 1;
    color: $color-gray-scorpion;
  }

  &__card-button {
    margin-top: 1.25em;
  }

  &__swiper-border {
    position: absolute;
    height: 100%;
    top: 0;
    width: 2em;
    z-index: 1;

    @include breakpoint($breakpoint-m) {
      background: $color-white;
      padding: 1.5625em 0;

      &--left {
        background: linear-gradient(
          90deg,
          rgba($color-gray-wild-sand, 0.5) 0%,
          rgba($color-gray-wild-sand, 0) 100%
        );
        left: 0;
      }

      &--right {
        background: linear-gradient(
          270deg,
          rgba($color-gray-wild-sand, 0.5) 0%,
          rgba($color-gray-wild-sand, 0) 100%
        );
        right: 0;
      }
    }
  }
}
</style>
